import { render, staticRenderFns } from "./WsMultiSelectDialog.vue?vue&type=template&id=cbc4e92e&"
import script from "./WsMultiSelectDialog.vue?vue&type=script&lang=js&"
export * from "./WsMultiSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports